module.exports = __webpack_public_path__ + "static/connect-hero2-9337f1e3f966a56a64cd4432e243a0bf.png";